import { useEffect, useRef, useState } from 'react';
import api from '../../../../services/api';
import { useTopologyBase } from './topologyApi';

/**
 * Hook: polling de métricas de node (CPU, MEM, Temp, PPPoE) + sessões BGP/OSPF
 * a cada N segundos.
 *
 * Retorna {
 *   metrics: { node_id: {cpu_pct, mem_pct, temp_c, pppoe_sessions} },
 *   sessions: { edge_id: {state, protocol, up} },
 *   loading
 * }
 */
export default function useTopologyMetrics({ intervalMs = 15000, enabled = true } = {}) {
  const base = useTopologyBase();
  const [metrics, setMetrics] = useState({});
  const [sessions, setSessions] = useState({});
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);

  const fetchAll = async () => {
    if (!base || !enabled) return;
    try {
      const [mRes, sRes] = await Promise.allSettled([
        api.get(`${base}/metrics`),
        api.get(`${base}/sessions`),
      ]);
      if (mRes.status === 'fulfilled') setMetrics(mRes.value.data?.metrics || {});
      if (sRes.status === 'fulfilled') setSessions(sRes.value.data?.sessions || {});
    } catch {
      // silencioso
    }
  };

  useEffect(() => {
    if (!base || !enabled) {
      setMetrics({});
      setSessions({});
      return;
    }
    setLoading(true);
    fetchAll().finally(() => setLoading(false));
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(fetchAll, intervalMs);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [base, enabled]);

  return { metrics, sessions, loading };
}
